import { useNeedsReviewQueue } from "@/features/cosignature/api/queries/useNeedsReviewQueue";

import type { CosignatureTab } from "../types";
import { CosignatureTable } from "../(table)/CosignatureTable";
import { Filters } from "../(filters)/Filters";
import type { FiltersProps } from "../(filters)/Filters";

export type CosignatureFilterControls = Omit<FiltersProps, "tab">;

type CosignaturePanelProps = {
  filters: CosignatureFilterControls;
  onClearFilters?: VoidFunction;
  tab: CosignatureTab;
};

export function CosignaturePanel({ filters, onClearFilters, tab }: CosignaturePanelProps) {
  const { data, isLoading } = useNeedsReviewQueue({
    cosignature_status: filters.status ?? undefined,
    supervisor_id: filters.supervisor_id ?? undefined,
  });

  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <Filters tab={tab} {...filters} />

      <CosignatureTable data={data} isLoading={isLoading} onClearFilters={onClearFilters} />
    </div>
  );
}
